export default __webpack_public_path__ + "static/media/master_footer_inverted.5872074b.png";